var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinishLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 197,
    viewBox: "0 0 200 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 192.148C155.228 192.148 200 149.134 200 96.074C200 43.0138 155.228 0 100 0C44.7715 0 0 43.0138 0 96.074C0 149.134 44.7715 192.148 100 192.148Z",
    fill: "url(#paint0_radial_14251_41466)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.882 172.069C53.8973 172.069 45.1173 170.475 33.8613 168.135C51.862 182.739 72.2267 192.313 97.63 191.896C156.679 190.927 193.13 154.207 199.549 105.267C169.813 145.771 121.396 172.069 65.882 172.069Z",
    fill: "url(#paint1_linear_14251_41466)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.939 36.499C67.939 36.499 51.9963 41.753 44.9656 47.2084C37.935 52.6657 37.377 55.5824 37.377 55.5824C37.377 55.5824 57.463 45.5644 62.3943 45.8397L67.221 45.603C67.221 45.603 69.4216 38.8897 67.939 36.499Z",
    fill: "#00375A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.627 30.5742C133.627 30.5742 149.889 39.2309 156.475 46.4449C163.061 53.6562 163.123 56.9175 163.123 56.9175C163.123 56.9175 143.625 42.0796 138.239 41.4582L132.707 40.5562C132.707 40.5562 131.577 32.8836 133.627 30.5742Z",
    fill: "#00375A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.752 132.313C76.752 132.313 85.3946 147.836 83.9066 154.409C82.4193 160.981 107.421 161.647 110.421 158.314C113.421 154.981 117.422 135.98 117.422 132.98C117.422 129.981 103.087 142.98 76.752 132.313Z",
    fill: "#720D53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7139 129.283C76.7139 129.283 96.2306 143.303 116.584 129.906C116.584 129.906 114.633 126.167 117.979 127.102C121.325 128.037 127.737 133.645 123.833 133.645C119.929 133.645 118.537 131.464 118.537 131.464C118.537 131.464 111.844 140.189 94.8366 138.318C77.8293 136.449 74.7632 130.84 74.7632 130.84C74.7632 130.84 68.9053 132.829 68.3479 130.959C67.7899 129.09 79.2359 122.454 76.7139 129.283Z",
    fill: "#00375A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.751 156.012C108.632 153.479 103.445 150.286 97.376 150.605C89.0747 151.043 84.984 154.21 83.8613 155.241C84.574 161.032 107.552 161.503 110.419 158.315C110.849 157.839 111.297 157.035 111.751 156.012Z",
    fill: "#D541A0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M101.822 150.978C100.63 150.72 99.3797 150.582 98.0877 150.592C96.5677 152.782 94.5797 156.555 95.757 160.096C96.529 160.16 97.3057 160.207 98.0797 160.236C98.383 157.814 99.1017 154.177 101.822 150.978Z",
    fill: "#720D53"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5762 163.149C89.5762 163.149 100.684 167.165 107.373 162.647C107.373 162.647 101.863 174.671 89.5762 163.149Z",
    fill: "#00375A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M79.4452 35.0959C92.9581 32.5379 103.094 26.1413 102.085 20.8087C101.075 15.476 89.3026 13.2266 75.7897 15.7845C62.2767 18.3424 52.1406 24.739 53.15 30.0717C54.1595 35.4044 65.9322 37.6538 79.4452 35.0959Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M182.615 117.24C186.011 130.045 176.94 143.56 162.356 147.429C147.772 151.297 133.198 144.052 129.802 131.247C126.406 118.442 135.478 104.926 150.061 101.058C164.646 97.1897 179.22 104.434 182.615 117.24Z",
    fill: "url(#paint2_radial_14251_41466)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.095 137.882C65.1884 150.913 46.7224 154.655 30.8477 146.241C14.975 137.827 7.70638 120.444 14.6124 107.413C21.519 94.3826 39.987 90.64 55.859 99.0546C71.7337 107.469 79.0024 124.851 72.095 137.882Z",
    fill: "url(#paint3_radial_14251_41466)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100 196.148C155.228 196.148 200 153.134 200 100.074C200 47.0138 155.228 4 100 4C44.7715 4 0 47.0138 0 100.074C0 153.134 44.7715 196.148 100 196.148Z",
    fill: "url(#paint4_radial_14251_41466)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8807 176.069C53.896 176.069 45.1154 174.475 33.8594 172.135C51.8607 186.739 72.2254 196.313 97.628 195.896C156.677 194.927 193.128 158.207 199.547 109.267C169.811 149.771 121.395 176.069 65.8807 176.069Z",
    fill: "url(#paint5_linear_14251_41466)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.502 97.7738C105.502 116.198 120.139 131.133 138.197 131.133C156.252 131.133 170.892 116.198 170.892 97.7738C170.892 79.3491 156.252 64.4131 138.197 64.4131C120.139 64.4138 105.502 79.3498 105.502 97.7738Z",
    fill: "#30688A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.063 94.4614C105.026 112.704 119.487 127.52 137.364 127.559C155.241 127.595 169.766 112.838 169.803 94.5967C169.842 76.3547 155.381 61.5374 137.501 61.5001C119.625 61.4627 105.1 76.2214 105.063 94.4614Z",
    fill: "#30688A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.131 94.4672C108.097 110.981 121.188 124.393 137.371 124.428C153.553 124.463 166.7 111.104 166.735 94.5899C166.769 78.0786 153.678 64.6652 137.497 64.6319C121.314 64.5986 108.166 77.9559 108.131 94.4672Z",
    fill: "url(#paint6_radial_14251_41466)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.38 119.771C152.794 119.804 165.445 107.684 166.641 92.2623C166.699 93.0316 166.736 93.8063 166.735 94.5897C166.7 111.104 153.554 124.462 137.371 124.428C121.188 124.392 108.097 110.981 108.131 94.467C108.132 93.6836 108.173 92.9096 108.234 92.1396C109.368 107.565 121.966 119.739 137.38 119.771Z",
    fill: "#00375A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M108.924 94.3902C108.906 102.706 115.634 109.46 123.949 109.476C132.263 109.495 139.019 102.768 139.037 94.4523C139.055 86.1369 132.327 79.3829 124.012 79.3662C115.697 79.3482 108.94 86.0736 108.924 94.3902Z",
    fill: "#4EC2EE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M112.57 94.4015C112.561 98.6022 115.96 102.014 120.16 102.024C124.361 102.032 127.774 98.6335 127.782 94.4349C127.79 90.2315 124.392 86.8202 120.191 86.8115C115.99 86.8022 112.578 90.2015 112.57 94.4015Z",
    fill: "#001C2D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M122.736 94.6243C122.716 103.47 129.87 110.655 138.717 110.675C147.564 110.692 154.75 103.538 154.768 94.691C154.786 85.847 147.631 78.6596 138.785 78.6416C129.938 78.6236 122.751 85.779 122.736 94.6243Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M110.365 94.1551C110.359 96.2118 112.094 97.8851 114.236 97.8891C116.381 97.8945 118.121 96.2292 118.125 94.1718C118.131 92.1138 116.397 90.4445 114.253 90.4385C112.109 90.4345 110.369 92.0978 110.365 94.1551Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.1556 131.103C79.2124 131.103 93.8503 116.168 93.8503 97.7441C93.8503 79.3202 79.2124 64.3848 61.1556 64.3848C43.0988 64.3848 28.4609 79.3202 28.4609 97.7441C28.4609 116.168 43.0988 131.103 61.1556 131.103Z",
    fill: "#30688A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M30.3379 94.471C30.3379 112.218 44.4372 126.605 61.8346 126.605C79.2279 126.605 93.3279 112.218 93.3279 94.471C93.3279 76.723 79.2279 62.335 61.8346 62.335C44.4372 62.335 30.3379 76.723 30.3379 94.471Z",
    fill: "#30688A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.588 94.3604C28.548 112.546 42.9673 127.318 60.7906 127.356C78.6153 127.395 93.0933 112.681 93.1333 94.4937C93.1713 76.309 78.7546 61.5397 60.928 61.5011C43.1073 61.4631 28.6273 76.1744 28.588 94.3604Z",
    fill: "#30688A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6485 94.3665C31.6112 110.828 44.6632 124.199 60.7972 124.234C76.9299 124.267 90.0359 110.95 90.0705 94.4885C90.1052 78.0265 77.0565 64.6538 60.9212 64.6212C44.7872 64.5865 31.6799 77.9052 31.6485 94.3665Z",
    fill: "url(#paint7_radial_14251_41466)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.8059 119.593C76.1732 119.625 88.7878 107.543 89.9812 92.1692C90.0358 92.9332 90.0732 93.7086 90.0705 94.4892C90.0358 110.951 76.9298 124.267 60.7972 124.235C44.6632 124.2 31.6112 110.829 31.6485 94.3672C31.6499 93.5879 31.6892 92.8119 31.7472 92.0459C32.8765 107.426 45.4392 119.561 60.8059 119.593Z",
    fill: "#00375A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0059 94.2945C58.9872 102.582 65.6926 109.317 73.9819 109.335C82.2726 109.351 89.0099 102.644 89.0286 94.3545C89.0452 86.0665 82.3372 79.3312 74.0486 79.3145C65.7552 79.2965 59.0212 86.0045 59.0059 94.2945Z",
    fill: "#4EC2EE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2266 94.6116C69.2192 98.799 72.6072 102.2 76.7952 102.209C80.9832 102.219 84.3852 98.8317 84.3932 94.6437C84.4019 90.455 81.0159 87.0543 76.8279 87.043C72.6379 87.035 69.2379 90.4263 69.2266 94.6116Z",
    fill: "#001C2D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M45.7461 92.6249C45.7315 100.42 52.0368 106.755 59.8348 106.773C67.6335 106.788 73.9681 100.479 73.9841 92.6829C74.0028 84.8842 67.6915 78.5515 59.8948 78.5342C52.0961 78.5175 45.7641 84.8275 45.7461 92.6249Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9512 94.8027C79.9445 96.854 81.6745 98.5187 83.8119 98.5227C85.9472 98.5274 87.6839 96.868 87.6885 94.818C87.6932 92.7667 85.9652 91.0994 83.8272 91.0967C81.6925 91.0894 79.9552 92.748 79.9512 94.8027Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M79.4452 39.0949C92.9582 36.537 103.094 30.1404 102.085 24.8077C101.075 19.475 89.3026 17.2256 75.7897 19.7835C62.2767 22.3414 52.1406 28.738 53.15 34.0707C54.1595 39.4034 65.9322 41.6528 79.4452 39.0949Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5915 130.094C37.5915 130.094 42.2522 147.018 79.6889 152.01C117.127 157.002 152.098 143.711 158.664 131.854C158.664 131.854 172.52 128.465 170.856 135.121C167.59 138.168 160.404 134.685 160.404 134.685C160.404 134.685 132.102 162.771 83.1155 155.586C40.9749 149.405 35.5962 132.876 35.5962 132.876C35.5962 132.876 24.7815 137.036 26.4455 132.044C28.1095 127.052 39.5462 125.159 37.5915 130.094Z",
    fill: "#00375A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89 163.47C89 163.47 93.9413 164.318 104.609 162.794C115.277 161.27 118.829 160.203 118.829 160.203C118.829 160.203 113.258 164.65 105.328 165.647C95.0413 166.94 89 163.47 89 163.47Z",
    fill: "#00375A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M161.061 125.797C161.061 125.797 169.671 125.478 171.266 128.986C172.862 132.495 173.498 129.943 173.498 128.348C173.497 126.754 169.034 121.013 161.061 125.797Z",
    fill: "#00375A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M36.358 123.565C36.358 123.565 27.746 123.246 26.1513 126.754C24.5566 130.263 23.918 127.711 23.918 126.117C23.918 124.522 28.3833 118.78 36.358 123.565Z",
    fill: "#00375A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9377 31.4346C67.9377 31.4346 51.9937 36.6886 44.9643 42.1439C37.9337 47.6006 37.375 50.5172 37.375 50.5172C37.375 50.5172 57.4617 40.4992 62.393 40.7746L67.219 40.5386C67.2197 40.5386 69.421 33.8246 67.9377 31.4346Z",
    fill: "#00375A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M133.626 25.5098C133.626 25.5098 149.888 34.1664 156.473 41.3798C163.058 48.5918 163.12 51.8524 163.12 51.8524C163.12 51.8524 143.623 37.0144 138.236 36.3931L132.705 35.4904C132.705 35.4911 131.575 27.8184 133.626 25.5098Z",
    fill: "#00375A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14251_41466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.1477 51.7427) scale(262.019)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0224,
    stopColor: "#E4F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    stopColor: "#53C3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5866,
    stopColor: "#006EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A2DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14251_41466",
    x1: 126.653,
    y1: 157.216,
    x2: 137.738,
    y2: 180.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0224,
    stopColor: "#001C2D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C2D",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14251_41466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.031 123.863) rotate(-23.2216) scale(22.7304 15.8309)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D541A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#D541A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14251_41466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.0145 122.671) rotate(20.094) scale(27.9885 18.2742)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D541A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#D541A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_14251_41466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.147 55.7425) scale(262.018)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0224,
    stopColor: "#E4F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    stopColor: "#53C3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5866,
    stopColor: "#006EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A2DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14251_41466",
    x1: 126.651,
    y1: 161.216,
    x2: 137.736,
    y2: 184.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0224,
    stopColor: "#001C2D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C2D",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_14251_41466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.319 94.8127) rotate(-179.882) scale(29.6021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6342,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7821,
    stopColor: "#EDF8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCECF8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_14251_41466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.0241 94.6463) rotate(-179.884) scale(29.51)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6342,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7821,
    stopColor: "#EDF8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCECF8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishLogo);
export default __webpack_public_path__ + "static/media/FinishLogo.30f5200fe11f4957165b7283ff03deea.svg";
export { ForwardRef as ReactComponent };